export default {
  uzAsboList: {},
  uzAsboLists: [],
  monthly: {},
}
